import React from 'react'
import CIcon from '@coreui/icons-react'
import { cilSpreadsheet } from '@coreui/icons'
import { CNavGroup, CNavItem } from '@coreui/react'

import _modules from '../../_modules'
import general_ledgers from '../../collectionsStructure/account-general_ledgers'
import vouchers from '../../collectionsStructure/account-vouchers'
import voucher_types from '../../collectionsStructure/account-voucher_types'
import banks from '../../collectionsStructure/account-banks'
import credit_cards from '../../collectionsStructure/account-credit_cards'
import debit_cards from '../../collectionsStructure/account-debit_cards'
import account_settings from '../../collectionsStructure/account_management-account_settings'

const account_items = {
  component: CNavGroup,
  name: 'Account',
  icon: <i className="material-icons-outlined">account_balance</i>,
  items: [],
}
let output = []

if (
  _modules.ledgers ||
  _modules.vouchers ||
  _modules.banks ||
  _modules.credit_cards ||
  _modules.debit_cards ||
  _modules.taxes ||
  _modules.account_settings
) {
  if (_modules.ledgers)
    account_items.items.push({
      component: CNavItem,
      name: 'System Ledgers',
      to: '/general-ledgers',
      permissionSource: general_ledgers.permissionSource,
      icon: <i className="material-icons-outlined">account_balance_wallet</i>,
    })
  if (_modules.vouchers)
    account_items.items.push({
      component: CNavItem,
      name: 'Vouchers',
      to: '/vouchers',
      permissionSource: vouchers.permissionSource,
      icon: <i className="material-icons-outlined">wallet</i>,
    })
  if (_modules.banks)
    account_items.items.push({
      component: CNavItem,
      name: 'Banks',
      to: '/banks',
      permissionSource: banks.permissionSource,
      icon: <i className="material-icons-outlined">paid</i>,
    })
  if (_modules.credit_cards)
    account_items.items.push({
      component: CNavItem,
      name: 'Credit Cards',
      to: '/credit-cards',
      permissionSource: credit_cards.permissionSource,
      icon: <i className="material-icons-outlined">paid</i>,
    })
  if (_modules.debit_cards)
    account_items.items.push({
      component: CNavItem,
      name: 'Debit Cards',
      to: '/debit-cards',
      permissionSource: debit_cards.permissionSource,
      icon: <i className="material-icons-outlined">paid</i>,
    })
  /*if (_modules.taxes)
    account_items.items.push({
      component: CNavItem,
      name: 'Tax Detail',
      to: '/taxes',
      permissionSource: tax_settings.permissionSource,
      icon: <i className="material-icons-sharp">payments</i>,
    })*/
  if (_modules.account_settings)
    account_items.items.push({
      component: CNavItem,
      name: 'Account Setting',
      to: '/account-settings',
      permissionSource: account_settings.permissionSource,
      icon: <i className="material-icons-outlined">account_tree</i>,
    })

  output.push(account_items)
}

export default output
